import React, { Component } from 'react';
import { IconButton, SvgIcon  } from '@material-ui/core';
//import {blue500, red500, greenA200} from 'material-ui/styles/colors';
import LanguageIcon from '@material-ui/icons/Language';
import PropTypes from 'prop-types'
//import './IconButtonStyle.css';
import styled from 'styled-components';

const iconStyles = {
  marginRight: 12,
  verticalAlign: 'middle',
};


const A = styled.a`
    &:link, &:visited {
        background-color: #ffff;
        color: #666666;
        padding: '14px 25px';
        text-align: center;
        vertical-align: middle;
        text-decoration: none;
        display: inline-block;
    }

    &:hover, &:active {
        background-color: #dddddd;
    }
`;

const DIV = styled.div`
   
    &:hover, &:active {
        background-color: #ffff;
    }
`;


const HomeIcon = (props) => (
    <SvgIcon {...props}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );


class IconButtonLink extends Component {
    constructor(props) {
      super(props);
    }

/*
    render() {
        return(
        <div>
            <a href={this.props.url} target={this.props.target} >
                <HomeIcon style={iconStyles}  />{this.props.text}
            </a >
        </div>
        )
    }
    */
   render() {
    return(
    <DIV>
        <A href={this.props.url} target={this.props.target} >
            <LanguageIcon style={iconStyles}  />{this.props.text}
        </A >
    </DIV>
    )
}
}
 
IconButtonLink.propTypes = {
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired
}

export default IconButtonLink;
